import React from 'react'
import VirtualList from 'react-tiny-virtual-list'
const DefaultItemHeight = 40

const CustomMenuList = ({ options, children, maxHeight, getValue }) => {
    const renderItem = (props) => {
        if (Array.isArray(children)) {
            return (
                <li style={props.style} key={props.index}>
                    {children[props.index]}
                </li>
            )
        }
        return (
            <li
                key={props.index}
                className="react-virtualized-menu-placeholder"
            >
                {children.props.children}
            </li>
        )
    }

    const [value] = getValue()
    const initialOffset = options.indexOf(value) * DefaultItemHeight
    const childrenOptions = React.Children.toArray(children)
    // in place of 35 was a variable of DefaultItemHeight
    const wrapperHeight =
        maxHeight < childrenOptions.length * 35
            ? maxHeight
            : childrenOptions.length * 35
    return (
        <span className="react-virtualized-list-wrapper">
            
            <VirtualList
                width="100%"
                height={wrapperHeight+6}
                scrollOffset={initialOffset}
                itemCount={childrenOptions.length}
                itemSize={DefaultItemHeight}
                renderItem={renderItem}
            />
        </span>
    )
}

export default CustomMenuList
